import { createSelector } from '@ngrx/store';

import { safeSelect, StateSelector } from '@fcom/core/selectors/selector-utils';
import { Step } from '@fcom/common/interfaces/step.interface';
import { BookingFeatureState } from '@fcom/common/interfaces/booking/booking-state.interface';
import { bookingFeatureState } from '@fcom/common/store/selectors/booking-feature-state.selector';

const _bookingState = createSelector(bookingFeatureState, (_bs: BookingFeatureState) => _bs?.booking);

export const bookingStepSelector = createSelector(_bookingState, (_state) => _state?.step);

export const bookingStep = (): StateSelector<BookingFeatureState, Step> => safeSelect(bookingStepSelector);
